<template lang="pug">
  v-app
    app-toolbar(v-if="showAppToolbar")
    app-drawer(v-if="showAppDrawer")
    ErrorResponseDialog
    v-content.app-content( height="100%")
      v-container.app-container(height="100%")
        router-view
    v-footer.footer(app align-center justify-center)
      span {{ $t('loginPage.lunchMenuLabel') }}

</template>

<script lang="ts">
import Vue from 'vue'
import { IS_USER_LOGGED_IN } from './store/getter-types'
import AppToolbar from '@/components/AppToolbar.vue'
import AppDrawer from './components/AppDrawer.vue'
import '../node_modules/ag-grid-community/dist/styles/ag-grid.css'
import '../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css'
import '../node_modules/ag-grid-community/dist/styles/ag-theme-material.css'
import '../node_modules/vue-virtual-scroller/dist/vue-virtual-scroller.css'
import ErrorResponseDialog from "@/components/ErrorResponseDialog.vue";

export default Vue.extend({
  name: 'App',

  components: {
    AppToolbar,
    AppDrawer,
    ErrorResponseDialog
  },

  computed: {
    isUserLoggedIn (): boolean {
      return this.$store.getters[IS_USER_LOGGED_IN]
    },

    showAppToolbar(): boolean {
      if (this.$route.name === 'RedirectToNewAddress') {
        return false
      }

      return this.isUserLoggedIn
    },

    showAppDrawer(): boolean {
      if (this.$route.name === 'RedirectToNewAddress') {
        return false
      }

      return this.isUserLoggedIn
    },
  },
})
</script>

<style lang="stylus">
    // v-select ma zobrazeny prazdny input ktory tam zavadazia
    .v-select__selections input
        display none
</style>

<style lang="stylus" scoped>
.app-content
    height 100%

    .app-container
        height 100%
        max-width none

.footer
    justify-content center
    font-size x-small

>>> .v-list .v-icon
    width 30px
</style>
